import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('electrical-control/index', {params});
    },
    getChart(params) {
        return Service().get('electrical-control/get-chart', {params});
    },
    show(id) {
        return Service().get('electrical-control/show/'+id);
    },
    create(params) {
        return Service().post('electrical-control/create', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    update(id, params) {
        return Service().post('electrical-control/update/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    delete(id) {
        return Service().post('electrical-control/delete/'+id);
    },
    machineDetail(params) {
        return Service().get('electrical-control/machine-detail', {params});
    },
}